// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"4a9212c2","447":"486de796","552":"c60e0e32","687":"2523203b","728":"cae2adbe","741":"78fbd6f3","823":"d481a786","939":"725d04e8","979":"0667ab73"}[chunkId] + ".chunk.css";
};